// extracted by mini-css-extract-plugin
module.exports = {"warp":"Navigation_warp__3baJi","title":"Navigation_title__3fwiZ","menus":"Navigation_menus__l3fOs","menuItem":"Navigation_menuItem__1Wdgb","side":"Navigation_side__2MCDa"};